import React from "react";
import { Link } from "react-router-dom";
import { Rocket, CalendarDays } from "lucide-react";
import { CALENDLY_DEMO_URL } from "@/constants/links";
import ctaVideo from "@/assets/video_b78414c21e7f.mp4";

export default function FinalCTA({
  title = "Ready to transform the way customers shop?",
  subtitle = "Start visualizing products in real spaces today.",
  primaryLabel = "Try NEIV Free",
  secondaryLabel = "Schedule Demo",
}) {
  return (
    <section className="bg-white py-16 sm:py-20 md:py-24">
      <div className="mx-auto max-w-5xl px-4 md:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-neutral-900 px-5 py-12 text-center sm:px-8 sm:py-16 md:px-16">
          {/* Background video, dimmed so text stays readable */}
          <video
            className="absolute inset-0 h-full w-full object-cover opacity-50"
            autoPlay
            muted
            loop
            playsInline
            src={ctaVideo}
            aria-hidden="true"
          />
          <div className="absolute inset-0 bg-neutral-900/40" aria-hidden="true" />

          <div className="relative">
            <h2 className="text-2xl font-bold text-white sm:text-3xl md:text-4xl">{title}</h2>
            <p className="mx-auto mt-4 max-w-xl text-base text-white/70 sm:text-lg">{subtitle}</p>
            <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Link
                to="/signup"
                className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-primary px-8 py-3.5 text-base font-semibold text-white transition-all hover:bg-primary/90 sm:w-auto"
              >
                <Rocket className="h-4 w-4" />
                {primaryLabel}
              </Link>
              {secondaryLabel && (
                <a
                  href={CALENDLY_DEMO_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-white/30 px-8 py-3.5 text-base font-semibold text-white transition-all hover:bg-white/10 sm:w-auto"
                >
                  <CalendarDays className="h-4 w-4" />
                  {secondaryLabel}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
